import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight, Loader2 } from "lucide-react";
import { ACTIVE, PHASES, money } from "@/lib/jammableApi";

/** Voice changes of this song: progress while they run, then links to the new song and its Mix Desk. */
export default function RevoiceJobs({ jobs }) {
  if (!jobs.length) return null;
  return (
    <div data-testid="jam-jobs" className="mt-6 space-y-2">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-fuchsia-200/80">Voice changes</p>
      {jobs.slice(0, 5).map((j) => (
        <div key={j.id} data-testid={`jam-job-${j.id}`} data-status={j.status} className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-2xl border border-white/[0.08] bg-black/25 px-4 py-2.5 text-[13px]">
          <span className="font-display font-semibold">{j.voice?.name}{j.pitch ? ` · ${j.pitch > 0 ? "+" : ""}${j.pitch}` : ""}</span>
          {ACTIVE.includes(j.status) ? (
            <span className="flex items-center gap-1.5 text-white/65"><Loader2 className="h-3.5 w-3.5 animate-spin text-fuchsia-200" /> {PHASES[j.status]}{j.status === "converting" && j.progress ? ` · ${j.progress}%` : "…"}</span>
          ) : j.status === "error" ? (
            <span data-testid={`jam-job-error-${j.id}`} className="flex items-center gap-1.5 text-rose-200"><AlertTriangle className="h-3.5 w-3.5" /> {j.error}</span>
          ) : j.result?.song_id ? (
            <>
              <span className="font-mono text-[10px] uppercase tracking-wider text-emerald-200">Ready · {money(j.cost ?? j.estimate)}</span>
              <Link to={`/create/song/${j.result.song_id}`} data-testid={`jam-job-open-${j.id}`} className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-wider text-fuchsia-100 hover:text-white">Open it <ArrowRight className="h-3.5 w-3.5" /></Link>
              <Link to={`/create/song/${j.result.song_id}/mix`} data-testid={`jam-job-mix-${j.id}`} className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-wider text-amber-200 hover:text-white">Mix desk <ArrowRight className="h-3.5 w-3.5" /></Link>
            </>
          ) : null}
        </div>
      ))}
    </div>
  );
}
